import React from 'react'

import NotificationsTable from '../../components/Notifications/NotificationsTable'

import { notifications } from '../../core/controllers/Notifications'
import { user } from '../../core/controllers/user';

export default class ActivityTemplate extends React.Component { 
    constructor(props) {
        super(props);

        this.state = {
            list: null
        };
    }

    render(){
        return (
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Activity Log</h4>
                            <p class="category">Stay up to date with the latest changes!</p>
                        </div>
                        <NotificationsTable />
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Activity/Activity.jsx